export enum AppointmentType {
  Video,
  Audio,
  InPerson,
  Reminder,
}
